<template>
  <div>
    <table class="table table-sm table-striped tabela-comparativo">
      <thead>
        <tr border="0">
          <th>Referencia</th>
          <th>torax</th>
          <th>cintura</th>
          <th>quadril</th>
          <th>gancho</th>

        </tr>
      </thead>
      <tbody >
          <tr>
            <td>Molde</td>
            <td>{{molde.torax}}</td>
            <td>{{molde.cintura}}</td>
            <td>{{molde.quadril}}</td>
            <td>{{molde.gancho}}</td>
          </tr>
        <tr>
            <td>Modelo</td>
            <td>{{modelo.torax}}</td>
            <td>{{modelo.cintura}}</td>
            <td>{{modelo.quadril}}</td>
            <td>{{modelo.gancho}}</td>
          </tr>
          <tr>
            <td>Diferença</td>
            <td :class="ClasseDiferenca(molde.torax, modelo.torax)">{{molde.diferenca_torax}}</td>
            <td :class="ClasseDiferenca(molde.cintura, modelo.cintura)">{{molde.diferenca_cintura}}</td>
            <td :class="ClasseDiferenca(molde.quadril, modelo.quadril)">{{molde.diferenca_quadril}}</td>
            <td :class="ClasseDiferenca(molde.gancho, modelo.gancho)">{{molde.diferenca_gancho}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>


  <script>
  export default {
    name: 'TabelaComparativo',
    data () {
      return {

      }
    },
    props:["molde", "modelo"],
    computed:{

    },
    created: function () {

    },
    methods:{
      ClasseDiferenca: function(x, y){
        if(x == y ) return 'igual'
          if(x > y ) return 'numMaior'
            if(y > x ) return 'numMenor'

          }

      }
    }
    </script>
    <style>
    .tabela-comparativo{border-top: 0px}
    .igual{font-weight: 500}
    .numMaior:before{content: "+"}
    .numMaior{color:#009fff; font-weight: 500}
    .numMenor:before{content: "-"}
    .numMenor{color:#c13644; font-weight: 500}
    </style>


// WEBPACK FOOTER //
// src/components/partes/TabelaComparativo.vue